import { getWorkflowsInfo } from 'api/workflows/workflowsThunk';
import { useAppDispatch } from 'redux/hooks';

export const useGetInfo = () => {
  const dispatch = useAppDispatch();

  return async ({ withLoading }: { withLoading: boolean }) => {
    try {
      await dispatch(getWorkflowsInfo({ withLoading })).unwrap();
    } catch (error) {
      console.error(error);
    }
  };
};
